import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { toast } from "react-toastify";
import Modal from "react-modal";
import "react-tabs/style/react-tabs.css";
import PaymentLinkTable from "./PaymentLinkTable";
import moment from "moment";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import PayoutsTable from "../components-bootstrap/PayoutsTable";
import {
  convertThenFormat,
  date_format_wrong,
  date_format_wrong_date,
  formatTimezoneThenStraight,
} from "../common-data/Converts";
import TableSkeleton from "../common-components/TableSkeleton";
import { BiBoxArrowUpRightIcon } from "../../images/icons/icons";

const OnlineCashTabs = ({
  userInfoData,
  allPaymentData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
}) => {
  const { allOnlinePaymentLinkDataLoading, allCashPaymentDataLoading } =
    useSelector((state) => state.api);

  const isShowPmLink =
    userInfoData?.account_type === "admin" ||
    userInfoData?.account_type === "cluster_manager";

  const {
    onlinePaymentData,
    onlinePagination,
    cashPaymentData,
    cashPagination,
  } = allPaymentData;

  const initialPMInfo = {
    partialModal: false,
    partialInfo: [],
  };
  const [pmDetails, setPMDetails] = useState(initialPMInfo);

  const handleTabChange = (index) => {
    setIsPage(0);
  };

  const onOnclickPM = (detail) => {
    const payments = JSON.parse(detail);

    if (payments?.payment?.length > 0) {
      setPMDetails({
        partialModal: true,
        partialInfo: payments?.payment,
      });
    } else {
      toast.error("No Detail Found!");
    }
  };

  const onlineTableColumns = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "name",
      text: "Member Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data bold minWidth150">
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase", fontWeight: "500" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "created_by",
      text: "Created By Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.created_by || "NA"}</span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.plan_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "amount",
      text: "link / total Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            ₹{convertThenFormat(row?.link_value || 0)}/
            {JSON.parse(row?.req_body)
              ? convertThenFormat(JSON.parse(row.req_body)?.price || 0)
              : 0}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Link Created On",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row.date_added.length <= 10
              ? date_format_wrong(row.date_added)
              : date_format_wrong_date(row.date_added)}
          </span>
        );
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data hoverBlue"
            style={{
              textDecoration: row?.is_partial === 1 ? "underline" : "none",
              fontWeight: row?.is_partial === 1 ? "700" : "500",
              color: row?.is_partial === 1 ? "#5F5DF0" : "#1e1e1e",
            }}
            onClick={() => onOnclickPM(row?.req_body)}
          >
            {row?.is_partial === 1
              ? "Partial"
              : row?.is_partial === 0
              ? "Full"
              : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "payment_through",
      text: "Payment source",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.payment_through || "NA"}</span>;
      },
    },
    {
      dataField: "status",
      text: "Payment Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 bold minWidth100"
            style={{
              background:
                row?.status === "pending"
                  ? "#E1EAF3"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#3474F1"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
            }}
          >
            {!isShowPmLink && row?.status === "pending"
              ? "Link Sent"
              : row?.status?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    isShowPmLink && {
      dataField: "payment_link",
      text: "Payment Link",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data text-primary"
            style={{ textDecoration: "underline", textTransform: "lowercase" }}
          >
            {row?.payment_link ? (
              <a
                className=""
                rel="noreferrer"
                target="_blank"
                href={row.payment_link}
              >
                <BiBoxArrowUpRightIcon />
              </a>
            ) : (
              "-"
            )}
          </span>
        );
      },
    },
  ];

  const cashTableColumns = [
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "name",
      text: "User Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data bold minWidth150">
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase", fontWeight: "500" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "created_by",
      text: "Created By Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.created_by || "NA"}</span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.plan_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "amount",
      text: "link / total Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            ₹{convertThenFormat(row?.link_value || 0)}/
            {JSON.parse(row.req_body)
              ? convertThenFormat(JSON.parse(row.req_body)?.price || 0)
              : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row.date_added
              ? formatTimezoneThenStraight(row.date_added)
              : // moment(row.date_added).tz("Asia/Kolkata").format("DD-MM-YYYY")
                "-"}
          </span>
        );
      },
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data hoverBlue"
            onClick={() => onOnclickPM(row?.req_body)}
          >
            {row?.is_partial === 1
              ? "Partial"
              : row?.is_partial === 0
              ? "Full"
              : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "payment_through",
      text: "Payment source",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.payment_through || "NA"}</span>;
      },
    },
    {
      dataField: "status",
      text: "Approval Status",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data minWidth150 withPadding borderRdius8 bold"
            style={{
              background:
                row?.is_approved === 1
                  ? "#B4E7B9"
                  : row?.is_approved === 0
                  ? "#E1EAF3"
                  : "#F3DADA",
              color:
                row?.is_approved === 1
                  ? "#0A701B"
                  : row?.is_approved === 0
                  ? "#3474F1"
                  : "#D90000",
            }}
          >
            {!isShowPmLink && row?.is_approved === 0
              ? "Link Sent"
              : row?.is_approved === 1
              ? "Approved"
              : row?.is_approved === 0
              ? "Pending"
              : row?.is_approved === -1
              ? "Not Approved"
              : "Can_ed/Resent" || "NA"}
          </span>
        );
      },
    },
    isShowPmLink && {
      dataField: "payment_link",
      text: "Payment Link",
      formatter: (_, row) => {
        return (
          <>
            {row?.is_approved === 1 ? (
              <span
                className="tb-data minWidth150 withPadding borderRdius8 bold"
                style={{
                  background: " #B4E7B9",
                  color: "#0A701B",
                }}
              >
                Completed
              </span>
            ) : !isShowPmLink ? (
              <span
                className="tb-data minWidth150 withPadding borderRdius8 bold"
                style={{
                  background: " #EB8317",
                  color: "#0A701B",
                }}
              >
                link sent
              </span>
            ) : (
              <span
                className="tb-data text-primary"
                style={{
                  textDecoration: "underline",
                  textTransform: "lowercase",
                }}
              >
                <a
                  className=""
                  rel="noreferrer"
                  target="_blank"
                  href={`https://wtfgyms.com//cash-details/${row?.uid}`}
                  // href={`https://wtfup.me/cash-details/${row?.uid}`}
                >
                  <BiBoxArrowUpRightIcon />
                </a>
              </span>
            )}
          </>
        );
      },
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "date",
      text: "Date",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth90">
            {moment(row?.date)?.tz("Asia/Kolkata")?.format("DD-MM-YYYY") ||
              "NA"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0)}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.status || "NA"}</span>;
      },
    },
    {
      dataField: "payment_mode",
      text: "payment mode",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.payment_mode || "NA"}</span>;
      },
    },
  ];

  return (
    <div className="fullWidthFlexCenter tabsContainer mt30 overflowAuto bgTransParent">
      <Modal
        isOpen={pmDetails.partialModal}
        onRequestClose={() => setPMDetails(initialPMInfo)}
        contentLabel="Payment Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer paymentDetailsModalContainer">
          <ModalHeadAndClose
            title="Payment Details"
            onClose={() => setPMDetails(initialPMInfo)}
          />

          <div className="tbWithoutPagination">
            <PayoutsTable
              dataValues={pmDetails.partialInfo}
              columnsValues={pmInfoColumns}
            />
          </div>
        </div>
      </Modal>

      <Tabs onSelect={handleTabChange}>
        <TabList>
          <Tab>Online</Tab>
          <Tab>Cash</Tab>
        </TabList>

        <TabPanel>
          {allOnlinePaymentLinkDataLoading ? (
            <TableSkeleton />
          ) : (
            <PaymentLinkTable
              tableData={onlinePaymentData?.length > 0 ? onlinePaymentData : []}
              tableColumns={onlineTableColumns}
              tablePagination={
                onlinePagination?.length > 0 ? onlinePagination : []
              }
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          )}
        </TabPanel>
        <TabPanel>
          {allCashPaymentDataLoading ? (
            <TableSkeleton />
          ) : (
            <PaymentLinkTable
              tableData={cashPaymentData?.length > 0 ? cashPaymentData : []}
              tableColumns={cashTableColumns}
              tablePagination={cashPagination?.length > 0 ? cashPagination : []}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          )}
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default OnlineCashTabs;
